/**
 * Created by roman.kupin on 10/3/2017.
 */


export const PREFIX = "[Partners]";
export const INITIALIZED = `${PREFIX}.Initialized`;


export function initialized(value) {
    return dispatch => {
        dispatch({ type: INITIALIZED, payload: value });
    }
}

export function getPartners(companyUuid) {
    return (dispatch, getState, { $http, environment }) => {
        return $http.get(`${environment.apiBaseUrl}/${companyUuid}/companies/${companyUuid}/partners`)
            .then((response) => {
                dispatch(initialized(response.data));
            });
    }
}

const All = { initialized, getPartners };
export default All;